import { useMemo } from 'react';

import { WATER_MARK } from '../../config/watermark';
import { buildWatermarkTile } from '../../utils/watermarkTile';

import './watermark.css';

/**
 * The app's watermark: WATER_MARK from src/config/watermark.js, tiled
 * faintly over the content area of every signed-in page.
 *
 * Mounted once in MainLayout (src/jsx/index.jsx). It is a single fixed
 * layer that takes no clicks, no selection and no focus, and stacks under
 * the sidebar and the top bar -- which is what keeps it to the content
 * area without measuring either. See watermark.css.
 */
const Watermark = () => {
  // The config is read once, when the app loads.
  const tile = useMemo(() => buildWatermarkTile(WATER_MARK), []);

  if (!tile) return null;

  return (
    <div
      className="lms-watermark"
      aria-hidden="true"
      // Built from the config text, so it is data -- the one kind of value
      // this app sets inline.
      style={{ WebkitMaskImage: tile, maskImage: tile }}
    />
  );
};

export default Watermark;
